import React from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { METODO_PAGAMENTO_PIX } from '../../../constants'

const WrapperPagamentoPixConclusao = styled.div`
  & > .titulo {
    ${StyleGuide.boldFonte}
    margin-top: 10px;

    small {
      ${StyleGuide.tipografia.textoHelper}
      ${StyleGuide.cores.cinza300}
    }
  }
`

const PagamentoPixConclusao = () => {
  return (
    <WrapperPagamentoPixConclusao>
      <p className="info">{ METODO_PAGAMENTO_PIX.visualizacao }</p>
    </WrapperPagamentoPixConclusao>
  )
}

export default PagamentoPixConclusao
